export default "__VITE_ASSET__Cx5qVlc9__"